var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6533 6.43059H11.4858C9.70832 6.43059 8.26082 4.98309 8.26082 3.20559V1.03809C8.26082 0.625586 7.92332 0.288086 7.51082 0.288086H4.33082C2.02082 0.288086 0.15332 1.78809 0.15332 4.46559V11.1106C0.15332 13.7881 2.02082 15.2881 4.33082 15.2881H10.2258C12.5358 15.2881 14.4033 13.7881 14.4033 11.1106V7.18059C14.4033 6.76809 14.0658 6.43059 13.6533 6.43059ZM7.48832 10.6231L5.98832 12.1231C5.93582 12.1756 5.86832 12.2206 5.80082 12.2431C5.73332 12.2731 5.66582 12.2881 5.59082 12.2881C5.51582 12.2881 5.44832 12.2731 5.38082 12.2431C5.32082 12.2206 5.26082 12.1756 5.21582 12.1306C5.20832 12.1231 5.20082 12.1231 5.20082 12.1156L3.70082 10.6156C3.48332 10.3981 3.48332 10.0381 3.70082 9.82059C3.91832 9.60309 4.27832 9.60309 4.49582 9.82059L5.02832 10.3681V7.22559C5.02832 6.91809 5.28332 6.66309 5.59082 6.66309C5.89832 6.66309 6.15332 6.91809 6.15332 7.22559V10.3681L6.69332 9.82809C6.91082 9.61059 7.27082 9.61059 7.48832 9.82809C7.70582 10.0456 7.70582 10.4056 7.48832 10.6231Z",
    fill: "#31BC0E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3506 5.39595C12.0631 5.40345 13.0531 5.40345 13.9006 5.40345C14.3281 5.40345 14.5531 4.90095 14.2531 4.60095C13.1731 3.51345 11.2381 1.55595 10.1281 0.445947C9.82059 0.138447 9.28809 0.348447 9.28809 0.775947V3.39345C9.28809 4.48845 10.2181 5.39595 11.3506 5.39595Z",
    fill: "#31BC0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.e455588e41f9f094b80b615206b213f4.svg";
export { ForwardRef as ReactComponent };